import { configure, defineRule } from 'vee-validate'
import { required, email, confirmed, numeric } from '@vee-validate/rules'
import { localize, setLocale } from '@vee-validate/i18n'
import da from '@vee-validate/i18n/dist/locale/da.json'
import nb_NO from '@vee-validate/i18n/dist/locale/nb_NO.json'
import sv from '@vee-validate/i18n/dist/locale/sv.json'
import fi from '@vee-validate/i18n/dist/locale/fi.json'
import { i18n } from './translate'

const ibantools = require('ibantools');

// Define rules
defineRule('required', required);
defineRule('mandatory', (value) => {
  if (!value) {
    return i18n.global.t('validation.mandatory');
  }
  return true;
});

defineRule('email', email);

defineRule('numeric', numeric);

defineRule('postal', (value, [digits]) => {
  if (value.length != digits) {
    return i18n.global.t('validation.postal', { digit: digits });
  }
  return true;
});

defineRule('hausnr', (value) => {
  if (!/^[a-zA-Z0-9-\s/]+$/.test(value)) {
    return i18n.global.t('validation.housenumber');
  }
  return true;
});

defineRule('password', (value) => {
  if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/.test(value)) {
    return i18n.global.t('validation.password');
  }
  return true;
});

defineRule('confirmed', confirmed);

defineRule('passwordLogin', (value) => {
  if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/.test(value)) {
    return i18n.global.t('validation.password');
  }
  return true;
});

defineRule('iban', (value) => {
  let allowedCountryCode = i18n.global.locale.value ? i18n.global.locale.value.toUpperCase() : 'NO'
  const countryCode = value.substring(0, 2)
  if (!((allowedCountryCode == countryCode) && ibantools.isValidIBAN(value.replace(/[^\dA-Z]/g, '')))) {
    return i18n.global.t(`validation.iban`);
  }
  return true;
});

defineRule('bic', (value) => {
  if (!ibantools.isValidBIC(value)) {
    return i18n.global.t(`validation.bic`);
  }
  return true;
});

defineRule('namesWithHyphensAndSpaces', (value) => {
  if (!/^([a-zA-ZßäöüÄÖÜÅåÅåÆæØø]{1,}(\s|-))*[a-zA-ZßäöüÄÖÜÅåÅåÆæØø]{1,}$/.test(value)) {
    return i18n.global.t(`validation.alpha`, { item: i18n.global.t(value) });
  }
  return true;
});

defineRule('mobileNumber', (value, [country]) => {
  let digit = 10;
  if (country === '45' || country == '47') {
    digit = 8;
    if (value.length != digit) {
      return i18n.global.t('validation.mobileNumber', { digit: digit });
    }
  } else if (country === '46') {
    digit = 11;
    if (value.length != digit) {
      return i18n.global.t('validation.mobileNumber', { digit: digit });
    }
  } else {
    if (value.length != digit) {
      return i18n.global.t('validation.mobileNumber', { digit: digit });
    }
  }
  return true;
});

defineRule('dateOfBirth', (value) => {
  return true;
});

// Configure VeeValidate
configure({
  generateMessage: localize({
    dk: {
      ...da,
      names: i18n.global.getLocaleMessage('dk').validation.names
    },
    se: {
      ...sv,
      names: i18n.global.getLocaleMessage('se').validation.names
    },
    fi: {
      ...fi,
      names: i18n.global.getLocaleMessage('fi').validation.names
    },
    no: {
      ...nb_NO,
      names: i18n.global.getLocaleMessage('no').validation.names
    }
  })
});

// Set the locale based on i18n
setLocale(i18n.global.locale || 'dk');
